module.exports = "/img/item-9.268a7fef.png";